/**
 * Sticky top navigation on the deep-green brand band: logo anchor, four section
 * links, and the "Demo starten" button. Link/button hover styles live in
 * src/styles.css (.nav-link / .btn-nav); everything else stays as inline style
 * objects exactly as the design authors it.
 */
import { PRODUCT_NAME_FULL } from "@/config";
import { ribbonDark } from "../../../brand/wordmark";

export function Nav({ onOpenDemo }: { onOpenDemo: () => void }) {
  return (
    <nav style={{ position: "sticky", top: 0, zIndex: 60, background: "var(--brand-deep)" }}>
      {/* min-height, not height: on narrow viewports the link row wraps, and the band has to
          grow with it — on the old cream header the overflow was simply invisible. */}
      <div style={{ maxWidth: "1120px", margin: "0 auto", padding: "12px 24px", minHeight: "66px", boxSizing: "border-box", display: "flex", alignItems: "center", gap: "14px 28px", flexWrap: "wrap" }}>
        <a href="#top" aria-label={PRODUCT_NAME_FULL}>
          <img className="ribbon-wordmark" src={ribbonDark} alt="" width={300} height={100} />
        </a>
        <div style={{ display: "flex", alignItems: "center", gap: "22px", flexWrap: "wrap", marginLeft: "auto" }}>
          <a href="#ablauf" className="nav-link">So funktioniert's</a>
          <a href="#vertrauen" className="nav-link">Vertrauen</a>
          <a href="#regeln" className="nav-link">Regelwerk</a>
          <a href="#faq" className="nav-link">FAQ</a>
          <button type="button" className="btn-nav" onClick={onOpenDemo}>Demo starten
            <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"></path><path d="M13 6l6 6-6 6"></path></svg>
          </button>
        </div>
      </div>
    </nav>
  );
}
